
if (typeof (window) !== 'undefined' && window.performance && window.performance.mark) {
  window.performance.mark('yotpo:loader:loaded');
}
var yotpoWidgetsContainer = yotpoWidgetsContainer || { guids: {} };
(function(){
    var guid = "a-wU-__6WAR57OA-e60oyQ";
    var loader = {
        loadDep: function (link, onLoad, strategy) {
            var script = document.createElement('script');
            script.onload = onLoad || function(){};
            script.src = link;
            if (strategy === 'defer') {
                script.defer = true;
            } else if (strategy === 'async') {
                script.async = true;
            }
            script.setAttribute("type", "text/javascript");
            script.setAttribute("charset", "utf-8");
            document.head.appendChild(script);
        },
        config: {
            data: {
                guid: guid
            },
            widgets: {
            
                "36864": {
                    instanceId: "36864",
                    instanceVersionId: "26197756",
                    templateAssetUrl: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widget-referred-friend/app.v0.4.2-4825.js",
                    cssOverrideAssetUrl: "",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,0.7)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_06_11_22_49_21_765",
                      "background-image-url-mobile": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_06_11_22_39_51_407",
                      "copy-code-copied-text": "COPIED",
                      "copy-code-icon-color": "rgba(158,161,240,1)",
                      "coupon-background-color": "#fafbfc",
                      "description-color": "#3e3a36",
                      "description-font-size": "22px",
                      "description-text": "Get $10 off your first lunchbox order over $100! ",
                      "email-activation": "false",
                      "email-capture-description-color": "#3e3a36",
                      "email-capture-description-font-size": "18px",
                      "email-capture-description-text": "Enter your email to get the referral code:",
                      "email-capture-title-color": "#47423e",
                      "email-capture-title-font-size": "26px",
                      "email-capture-title-text": "HEY, FRIEND! YOU'VE GOT A DISCOUNT ON YOUR FIRST PURCHASE.",
                      "error-already-used-coupon-text": "Looks like you’ve already used this offer",
                      "error-general-failure-text": "Oops! Looks like something went wrong generating your coupon code. Please refresh page to try again.",
                      "error-link-color": "#0042E4",
                      "error-message-invalid-email": "Please fill in a valid email address",
                      "error-message-invalid-email-text-color": "#f04860",
                      "error-message-text-color": "#f04860",
                      "error-not-eligible-coupon-text": "Looks like you’re not eligible to use this offer.",
                      "error-safari-hide-ip-text": "To get the discount code you’ll need to turn off the \"Hide IP address\" option in your Safari privacy settings, then click the referral link again.",
                      "next-button-background-color": "#393086",
                      "next-button-text": "Next",
                      "next-button-text-color": "#ffffff",
                      "next-button-type": "filled_rectangle",
                      "popup-background-color": "rgba(255,255,255,1)",
                      "primary-font-name-and-url": "Montserrat@600|https://fonts.googleapis.com/css?family=Montserrat:600\u0026display=swap",
                      "secondary-font-name-and-url": "Nunito Sans@400| https://fonts.googleapis.com/css?family=Nunito+Sans:400\u0026display=swap",
                      "start-button-background-color": "rgba(160,215,240,1)",
                      "start-button-text": "Start Shopping",
                      "start-button-text-color": "rgba(0,0,0,0.7)",
                      "start-button-type": "filled_capsule",
                      "text-design-choose-screen": "email_capture_display",
                      "title-color": "#47423e",
                      "title-font-size": "28px",
                      "title-text": "You've been personally invited by a fam member; welcome to lunchbox! "
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "forceEmailCapture": "false",
                      "isMultiCurrencyEnabled": false,
                      "merchantId": "57491",
                      "platformName": "shopify",
                      "selfExecutable": true,
                      "shouldShowInfoMessage": false,
                      "urlMatch": "https?://(?!yap.yotpo.com).*sref_id=.*"
                    },
                    className: "ReferredFriendWidget",
                    dependencyGroupId: null
                },
            
                "10288": {
                    instanceId: "10288",
                    instanceVersionId: "6965326",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-coupons-redemption/app.v0.3.22-2258.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CouponsRedemptionWidget/a-wU-__6WAR57OA-e60oyQ/css-overrides/css-overrides.2021_04_06_19_48_41_769.css",
                    customizationCssUrl: "",
                    customizations: {
                      "confirmation-step-cancel-option": "NO",
                      "confirmation-step-confirm-option": "YES",
                      "confirmation-step-title": "ARE YOU SURE?",
                      "coupon-background-type": "coupon",
                      "coupon-code-copied-message-body": "Thank you for redeeming your points. Please paste the code at checkout.",
                      "coupon-code-copied-message-color": "#707997",
                      "coupon-code-copied-message-title": "COPIED",
                      "coupons-redemption-description": "Redeeming your hard-earned points is easy! Simply click a redemption option below\nand redeem your points for a discount code that you can paste at checkout!",
                      "coupons-redemption-headline": "Redeem for Discounts",
                      "coupons-redemption-rule": "Every 100 Points = $5",
                      "description-color": "rgba( 255, 255, 255, 1 )",
                      "description-font-size": 20,
                      "disabled-outline-button-color": "#929292",
                      "donate-button-text": "DONATE",
                      "donation-success-message-body": "Thank you for donating ${{donation_amount}} to {{company_name}}",
                      "donation-success-message-color": "#707997",
                      "donation-success-message-title": "SUCCESS",
                      "error-message-color": "#f04860",
                      "error-message-title": "",
                      "headline-color": "rgba( 255, 255, 255, 1 )",
                      "headline-font-size": 48,
                      "login-button-color": "rgba(160,215,240,1)",
                      "login-button-text": "REDEEM MY POINTS",
                      "login-button-text-color": "white",
                      "login-button-type": "filled_rectangle",
                      "message-font-size": "14",
                      "next-subscription-headline-text": "NEXT ORDER",
                      "next-subscription-subtitle-text": "{{product_name}} {{next_order_amount}}",
                      "no-subscription-subtitle-text": "No ongoing subscriptions",
                      "point-balance-text": "You have {{current_point_balance}} points",
                      "points-balance-color": "#011247",
                      "points-balance-font-size": "20",
                      "points-balance-number-color": "#93a1eb",
                      "primary-font-name-and-url": "'Greycliff CF'@|",
                      "redeem-button-color": "#556DD8",
                      "redeem-button-text": "REDEEM",
                      "redeem-button-text-color": "white",
                      "redeem-button-type": "filled_rectangle",
                      "redemption-353358-displayname": "$10 Off",
                      "redemption-353358-settings-button-color": "rgba(160,215,240,1)",
                      "redemption-353358-settings-button-text": "REDEEM",
                      "redemption-353358-settings-button-text-color": "white",
                      "redemption-353358-settings-button-type": "filled_rectangle",
                      "redemption-353358-settings-call-to-action-button-text": "REDEEM",
                      "redemption-353358-settings-cost": "20",
                      "redemption-353358-settings-cost-color": "rgba(79,79,79,1)",
                      "redemption-353358-settings-cost-font-size": "20",
                      "redemption-353358-settings-cost-text": "{{points}} Points",
                      "redemption-353358-settings-coupon-cost-font-size": "15",
                      "redemption-353358-settings-coupon-reward-font-size": "29",
                      "redemption-353358-settings-discount-amount-cents": "1000",
                      "redemption-353358-settings-discount-type": "fixed_amount",
                      "redemption-353358-settings-reward": "$10 ",
                      "redemption-353358-settings-reward-color": "rgba(51,51,51,1)",
                      "redemption-353358-settings-reward-font-size": "30",
                      "redemption-353358-settings-success-message-text": "Discount Applied",
                      "redemption-353359-displayname": "$15 Off",
                      "redemption-353359-settings-button-color": "rgba(160,215,240,1)",
                      "redemption-353359-settings-button-text": "REDEEM",
                      "redemption-353359-settings-button-text-color": "white",
                      "redemption-353359-settings-button-type": "filled_rectangle",
                      "redemption-353359-settings-call-to-action-button-text": "REDEEM",
                      "redemption-353359-settings-cost": "30",
                      "redemption-353359-settings-cost-color": "rgba(79,79,79,1)",
                      "redemption-353359-settings-cost-font-size": "20",
                      "redemption-353359-settings-cost-text": "{{points}} Points",
                      "redemption-353359-settings-coupon-cost-font-size": "15",
                      "redemption-353359-settings-coupon-reward-font-size": "29",
                      "redemption-353359-settings-discount-amount-cents": "1500",
                      "redemption-353359-settings-discount-type": "fixed_amount",
                      "redemption-353359-settings-reward": "$15 ",
                      "redemption-353359-settings-reward-color": "rgba(51,51,51,1)",
                      "redemption-353359-settings-reward-font-size": "30",
                      "redemption-353359-settings-success-message-text": "Discount Applied",
                      "redemption-353360-displayname": "$20 Off",
                      "redemption-353360-settings-button-color": "rgba(160,215,240,1)",
                      "redemption-353360-settings-button-text": "REDEEM",
                      "redemption-353360-settings-button-text-color": "white",
                      "redemption-353360-settings-button-type": "filled_rectangle",
                      "redemption-353360-settings-call-to-action-button-text": "REDEEM",
                      "redemption-353360-settings-cost": "40",
                      "redemption-353360-settings-cost-color": "rgba(79,79,79,1)",
                      "redemption-353360-settings-cost-font-size": "20",
                      "redemption-353360-settings-cost-text": "{{points}} Points",
                      "redemption-353360-settings-coupon-cost-font-size": "15",
                      "redemption-353360-settings-coupon-reward-font-size": "29",
                      "redemption-353360-settings-discount-amount-cents": "2000",
                      "redemption-353360-settings-discount-type": "fixed_amount",
                      "redemption-353360-settings-reward": "$20 ",
                      "redemption-353360-settings-reward-color": "rgba(51,51,51,1)",
                      "redemption-353360-settings-reward-font-size": "30",
                      "redemption-353360-settings-success-message-text": "Discount Applied",
                      "redemption-353361-displayname": "$30 Off",
                      "redemption-353361-settings-button-color": "rgba(160,215,240,1)",
                      "redemption-353361-settings-button-text": "REDEEM",
                      "redemption-353361-settings-button-text-color": "white",
                      "redemption-353361-settings-button-type": "filled_rectangle",
                      "redemption-353361-settings-call-to-action-button-text": "REDEEM",
                      "redemption-353361-settings-cost": "60",
                      "redemption-353361-settings-cost-color": "rgba(79,79,79,1)",
                      "redemption-353361-settings-cost-font-size": "20",
                      "redemption-353361-settings-cost-text": "{{points}} Points",
                      "redemption-353361-settings-coupon-cost-font-size": "15",
                      "redemption-353361-settings-coupon-reward-font-size": "29",
                      "redemption-353361-settings-discount-amount-cents": "3000",
                      "redemption-353361-settings-discount-type": "fixed_amount",
                      "redemption-353361-settings-reward": "$30",
                      "redemption-353361-settings-reward-color": "rgba(51,51,51,1)",
                      "redemption-353361-settings-reward-font-size": "30",
                      "redemption-353361-settings-success-message-text": "Discount Applied",
                      "redemption-353362-displayname": "$50 Off",
                      "redemption-353362-settings-button-color": "rgba(160,215,240,1)",
                      "redemption-353362-settings-button-text": "REDEEM",
                      "redemption-353362-settings-button-text-color": "white",
                      "redemption-353362-settings-button-type": "filled_rectangle",
                      "redemption-353362-settings-call-to-action-button-text": "REDEEM",
                      "redemption-353362-settings-cost": "100",
                      "redemption-353362-settings-cost-color": "rgba(79,79,79,1)",
                      "redemption-353362-settings-cost-font-size": "20",
                      "redemption-353362-settings-cost-text": "{{points}} Points",
                      "redemption-353362-settings-coupon-cost-font-size": "15",
                      "redemption-353362-settings-coupon-reward-font-size": "29",
                      "redemption-353362-settings-discount-amount-cents": "5000",
                      "redemption-353362-settings-discount-type": "fixed_amount",
                      "redemption-353362-settings-reward": "$50",
                      "redemption-353362-settings-reward-color": "rgba(51,51,51,1)",
                      "redemption-353362-settings-reward-font-size": "30",
                      "redemption-353362-settings-success-message-text": "Discount Applied",
                      "redemption-353363-displayname": "$100",
                      "redemption-353363-settings-button-color": "rgba(160,215,240,1)",
                      "redemption-353363-settings-button-text": "REDEEM",
                      "redemption-353363-settings-button-text-color": "white",
                      "redemption-353363-settings-button-type": "filled_rectangle",
                      "redemption-353363-settings-call-to-action-button-text": "REDEEM",
                      "redemption-353363-settings-cost": "200",
                      "redemption-353363-settings-cost-color": "rgba(79,79,79,1)",
                      "redemption-353363-settings-cost-font-size": "20",
                      "redemption-353363-settings-cost-text": "{{points}} Points",
                      "redemption-353363-settings-coupon-cost-font-size": "15",
                      "redemption-353363-settings-coupon-reward-font-size": "29",
                      "redemption-353363-settings-discount-amount-cents": "10000",
                      "redemption-353363-settings-discount-type": "fixed_amount",
                      "redemption-353363-settings-reward": "$100",
                      "redemption-353363-settings-reward-color": "rgba(51,51,51,1)",
                      "redemption-353363-settings-reward-font-size": "30",
                      "redemption-353363-settings-success-message-text": "Discount Applied",
                      "rule-border-color": "rgba( 255, 255, 255, 1 )",
                      "rule-color": "rgba( 255, 255, 255, 1 )",
                      "rule-font-size": "18",
                      "secondary-font-name-and-url": "\"SF Pro Display\"@|",
                      "selected-extensions": [
                        "353358",
                        "353359",
                        "353360",
                        "353361",
                        "353362",
                        "353363"
                      ],
                      "selected-redemptions-modes": "regular",
                      "subscription-coupon-applied-message-body": "The discount was applied to your upcoming subscription order. You’ll be able to get another discount once the next order is processed.",
                      "subscription-coupon-applied-message-color": "#f04860",
                      "subscription-divider-color": "#c2cdf4",
                      "subscription-headline-color": "#666d8b",
                      "subscription-headline-font-size": "14",
                      "subscription-points-headline-text": "YOUR POINT BALANCE",
                      "subscription-points-subtitle-text": "{{current_point_balance}} Points",
                      "subscription-redemptions-description": "Choose a discount option that will automatically apply to your next subscription order.",
                      "subscription-redemptions-headline": "Redeem for Subscription Discount",
                      "subscription-subtitle-color": "#768cdc",
                      "subscription-subtitle-font-size": "20",
                      "view-layout": "full-layout"
                    },
                    staticContent: {
                      "baseCurrency": "USD",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "merchantId": "57491",
                      "platformName": "shopify",
                      "storeLoginUrl": "/account/login",
                      "subunitsPerUnit": 100
                    },
                    className: "CouponsRedemptionWidget",
                    dependencyGroupId: 2
                },
            
                "8661": {
                    instanceId: "8661",
                    instanceVersionId: "6966507",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-vip-tiers/app.v1.1.5-2260.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/VipTiersWidget/a-wU-__6WAR57OA-e60oyQ/css-overrides/css-overrides.2021_04_06_00_25_37_601.css",
                    customizationCssUrl: "",
                    customizations: {
                      "benefits-font-size": 18,
                      "benefits-icon-color": "rgb(115,142,217)",
                      "benefits-icon-type": "none",
                      "benefits-text-color": "rgba(79,79,79,1)",
                      "card-background-border-color": "rgba(79,79,79,1)",
                      "card-background-color": "rgba(242,242,242,1)",
                      "card-background-shadow": "true",
                      "card-separator-color": "rgba(51,51,51,1)",
                      "card-separator-type": "default",
                      "current-status-bg-color": "rgba( 255, 255, 255, 0 )",
                      "current-status-tag": "true",
                      "current-status-text": "Current Status",
                      "current-status-text-color": "rgba( 47, 80, 176, 1 )",
                      "current-tier-benefits-color": "rgba( 47, 80, 176, 1 )",
                      "current-tier-benefits-icon": "none",
                      "current-tier-benefits-icon-color": "#FFFFFF",
                      "current-tier-benefits-icon-url": "",
                      "current-tier-bg-color": "rgba( 0, 0, 0, 0 )",
                      "current-tier-border-color": "TRANSPARENT",
                      "current-tier-icon": "custom",
                      "current-tier-icon-color": "#FFFFFF",
                      "current-tier-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_13_11_45_03_879",
                      "current-tier-name-color": "rgba( 47, 80, 176, 1 )",
                      "current-tier-threshold-color": "rgba( 47, 80, 176, 1 )",
                      "grid-lines-color": "#000000",
                      "headline-font-size": 50,
                      "headline-text-color": "rgba(160,215,240,1)",
                      "layout": "card",
                      "primary-font-name-and-url": "'Greycliff CF'@|",
                      "progress-bar-current-status": "{{amount_spent}} Spent",
                      "progress-bar-enabled": "false",
                      "progress-bar-headline-font-size": "14px",
                      "progress-bar-primary-color": "#011247",
                      "progress-bar-secondary-color": "#768cdc",
                      "progress-bar-summary-current": "You have {{current_vip_tier_name}} through the next earning period.",
                      "progress-bar-summary-font-size": "14px",
                      "progress-bar-summary-maintain": "Spend {{spend_needed}} by {{tier_expiration_date}} to maintain {{current_vip_tier_name}}",
                      "progress-bar-summary-next": "Spend {{spend_needed}} by {{tier_expiration_date}} to unlock {{next_vip_tier_name}}.",
                      "progress-bar-tier-status": "Tier Status",
                      "progress-bar-you": "YOU",
                      "secondary-font-name-and-url": "\"SF Pro Display\"@|",
                      "selected-extensions": [
                        "3992",
                        "3993",
                        "3994",
                        "3995"
                      ],
                      "show-less-text": "- Show Less",
                      "show-more-text": "+ Show More",
                      "tier-spacing": "none",
                      "tiers-3992-design-header-bg-color": "rgba(242,242,242,1)",
                      "tiers-3992-design-icon-fill-color": "rgba( 47, 80, 177, 1 )",
                      "tiers-3992-design-icon-type": "custom",
                      "tiers-3992-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_08_07_23_04_855",
                      "tiers-3992-design-include-header-bg": "true",
                      "tiers-3992-design-name-font-size": "28px",
                      "tiers-3992-design-name-text-color": "rgba(51,51,51,1)",
                      "tiers-3992-design-threshold-font-size": "18px",
                      "tiers-3992-design-threshold-text-color": "rgba(79,79,79,1)",
                      "tiers-3992-text-benefits": "Annual Birthday Gift||Early Access To New Products",
                      "tiers-3992-text-name": "Bronze",
                      "tiers-3992-text-rank": "1",
                      "tiers-3992-text-threshold": "1-299 points earned (per rolling year)",
                      "tiers-3993-design-header-bg-color": "rgba(242,242,242,1)",
                      "tiers-3993-design-icon-fill-color": "rgba( 47, 80, 177, 1 )",
                      "tiers-3993-design-icon-type": "custom",
                      "tiers-3993-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_08_07_23_56_022",
                      "tiers-3993-design-include-header-bg": "true",
                      "tiers-3993-design-name-font-size": "28px",
                      "tiers-3993-design-name-text-color": "rgba(51,51,51,1)",
                      "tiers-3993-design-threshold-font-size": "18px",
                      "tiers-3993-design-threshold-text-color": "rgba(79,79,79,1)",
                      "tiers-3993-text-benefits": "Annual Birthday Gift||Early Access To New Products||Lunchbox Happy Hours Every 3 Months||Invite to Lunchbox Fam Festival Group Camp",
                      "tiers-3993-text-name": "Silver",
                      "tiers-3993-text-rank": "2",
                      "tiers-3993-text-threshold": "300-999 points earned (per rolling year)",
                      "tiers-3994-design-header-bg-color": "rgba(242,242,242,1)",
                      "tiers-3994-design-icon-fill-color": "rgba( 47, 80, 177, 1 )",
                      "tiers-3994-design-icon-type": "custom",
                      "tiers-3994-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_08_07_24_51_862",
                      "tiers-3994-design-include-header-bg": "true",
                      "tiers-3994-design-name-font-size": "28px",
                      "tiers-3994-design-name-text-color": "rgba(51,51,51,1)",
                      "tiers-3994-design-threshold-font-size": "18px",
                      "tiers-3994-design-threshold-text-color": "rgba(79,79,79,1)",
                      "tiers-3994-text-benefits": "Annual Birthday Gift||Early Access To New Products||Lunchbox Happy Hours||Lunchbox Team Festival Group Camp||Exclusive Product Launches||Redeem 1500 Points for a ticket to a show (Up to $50)",
                      "tiers-3994-text-name": "Gold",
                      "tiers-3994-text-rank": "3",
                      "tiers-3994-text-threshold": "1000-1999 points earned (per rolling year)",
                      "tiers-3995-design-header-bg-color": "rgba(242,242,242,1)",
                      "tiers-3995-design-icon-fill-color": "rgba( 47, 80, 177, 1 )",
                      "tiers-3995-design-icon-type": "custom",
                      "tiers-3995-design-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_08_07_28_00_944",
                      "tiers-3995-design-include-header-bg": "true",
                      "tiers-3995-design-name-font-size": "28px",
                      "tiers-3995-design-name-text-color": "rgba(160,215,240,1)",
                      "tiers-3995-design-threshold-font-size": "18px",
                      "tiers-3995-design-threshold-text-color": "rgba(160,215,240,1)",
                      "tiers-3995-text-benefits": "Annual Birthday Gift||Early Access To New Products||Lunchbox Happy Hours||Lunchbox Team Festival Group Camp||Exclusive Product Launches||Redeem 1500 Points for a ticket to a show (Up to $50)||Redeem 4000 points for a festival ticket (up to $150)||Lunchbox lottery - Win a USA festival ticket!",
                      "tiers-3995-text-name": "Platinum",
                      "tiers-3995-text-rank": "4",
                      "tiers-3995-text-threshold": "2000+ points earned (per rolling year)",
                      "widget-background-color": "#f5f5f5",
                      "widget-headline": "VIPs Earn Even More"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "merchantId": "57491",
                      "platformName": "shopify"
                    },
                    className: "VipTiersWidget",
                    dependencyGroupId: 2
                },
            
                "8659": {
                    instanceId: "8659",
                    instanceVersionId: "6962928",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-loyalty-campaigns/app.v0.6.1-2475.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/CampaignWidget/a-wU-__6WAR57OA-e60oyQ/css-overrides/css-overrides.2021_04_05_23_47_58_479.css",
                    customizationCssUrl: "",
                    customizations: {
                      "campaign-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-description-size": "18px",
                      "campaign-item-1040183-action-tile-action-text": "Follow Us",
                      "campaign-item-1040183-action-tile-title": "Earn 25 points when you follow us on Twitter",
                      "campaign-item-1040183-background-color": "#f9faff",
                      "campaign-item-1040183-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1040183-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_10_18_21_04_07_779",
                      "campaign-item-1040183-background-type": "image",
                      "campaign-item-1040183-border-color": "#848ca3",
                      "campaign-item-1040183-description-font-color": "rgba(249,250,255,1)",
                      "campaign-item-1040183-description-font-size": "18",
                      "campaign-item-1040183-icon-color": "#768cdc",
                      "campaign-item-1040183-icon-type": "defaultIcon",
                      "campaign-item-1040183-tile-description": "Follow us on Twitter",
                      "campaign-item-1040183-tile-reward": "25 Points",
                      "campaign-item-1040183-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-1040183-title-font-size": "27",
                      "campaign-item-1040183-type": "TwitterFollowCampaign",
                      "campaign-item-1040198-action-tile-action-text": "Follow Us",
                      "campaign-item-1040198-action-tile-title": "Earn 25 points when you follow us on TikTok!",
                      "campaign-item-1040198-background-color": "#f9faff",
                      "campaign-item-1040198-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1040198-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_10_18_22_38_01_195",
                      "campaign-item-1040198-background-type": "image",
                      "campaign-item-1040198-border-color": "#848ca3",
                      "campaign-item-1040198-description-font-color": "rgba(249,250,255,1)",
                      "campaign-item-1040198-description-font-size": "18",
                      "campaign-item-1040198-icon-color": "rgba(242,242,242,1)",
                      "campaign-item-1040198-icon-type": "defaultIcon",
                      "campaign-item-1040198-tile-description": "Follow us on TikTok!",
                      "campaign-item-1040198-tile-reward": "25 Points",
                      "campaign-item-1040198-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-1040198-title-font-size": "27",
                      "campaign-item-1040198-type": "FacebookPageVisitCampaign",
                      "campaign-item-1040206-action-tile-action-text": "Visit Page",
                      "campaign-item-1040206-action-tile-title": "Earn 25 points when you join our Facebook group",
                      "campaign-item-1040206-background-color": "#f9faff",
                      "campaign-item-1040206-background-image-color-overlay": "rgba(0, 0, 0, .4)",
                      "campaign-item-1040206-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_10_18_22_56_47_737",
                      "campaign-item-1040206-background-type": "image",
                      "campaign-item-1040206-border-color": "#848ca3",
                      "campaign-item-1040206-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-1040206-description-font-size": "18",
                      "campaign-item-1040206-icon-color": "rgba(249,250,255,1)",
                      "campaign-item-1040206-icon-type": "defaultIcon",
                      "campaign-item-1040206-tile-description": "Join our Facebook group",
                      "campaign-item-1040206-tile-reward": "25 Points",
                      "campaign-item-1040206-title-font-color": "rgba(249,250,255,1)",
                      "campaign-item-1040206-title-font-size": "27",
                      "campaign-item-1040206-type": "FacebookPageVisitCampaign",
                      "campaign-item-382924-action-tile-action-text": "Click here",
                      "campaign-item-382924-action-tile-title": "Scroll down for your code to refer friends! ",
                      "campaign-item-382924-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-382924-background-image-color-overlay": "rgba(0,0,0,0.42)",
                      "campaign-item-382924-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2022_05_14_17_18_36_927",
                      "campaign-item-382924-background-type": "image",
                      "campaign-item-382924-border-color": "rgba(255,255,255,1)",
                      "campaign-item-382924-description-font-color": "rgba(255,255,255,1)",
                      "campaign-item-382924-description-font-size": 20,
                      "campaign-item-382924-displayname": "Refer a Friend (382924)",
                      "campaign-item-382924-icon-color": "rgba(255,255,255,1)",
                      "campaign-item-382924-icon-type": "defaultIcon",
                      "campaign-item-382924-tile-description": "Refer a friend, and give them $ off on their first order! Scroll down this page to start referring.",
                      "campaign-item-382924-tile-reward": "200 Points",
                      "campaign-item-382924-title-font-color": "rgba(255,255,255,1)",
                      "campaign-item-382924-title-font-size": 32,
                      "campaign-item-382924-type": "FreeTextCampaign",
                      "campaign-item-382924-view-show-custom-action-button": "false",
                      "campaign-item-576444-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576444-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576444-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_38_09_318",
                      "campaign-item-576444-background-type": "image",
                      "campaign-item-576444-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576444-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576444-description-font-size": "18px",
                      "campaign-item-576444-hover-view-tile-message": "Earn 1 point for every $1 you spend",
                      "campaign-item-576444-icon-color": "#768cdc",
                      "campaign-item-576444-icon-type": "customIcon",
                      "campaign-item-576444-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_38_41_180",
                      "campaign-item-576444-tile-description": "$1 Dollar Spent",
                      "campaign-item-576444-tile-reward": "1 Point",
                      "campaign-item-576444-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576444-title-font-size": "27px",
                      "campaign-item-576444-type": "PointsForPurchasesCampaign",
                      "campaign-item-576445-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576445-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576445-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_35_02_832",
                      "campaign-item-576445-background-type": "image",
                      "campaign-item-576445-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576445-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576445-description-font-size": "18px",
                      "campaign-item-576445-hover-view-tile-message": "Earn 50 points when you create an account",
                      "campaign-item-576445-icon-color": "#768cdc",
                      "campaign-item-576445-icon-type": "customIcon",
                      "campaign-item-576445-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_37_41_581",
                      "campaign-item-576445-tile-description": "Create Account",
                      "campaign-item-576445-tile-reward": "50 Points",
                      "campaign-item-576445-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576445-title-font-size": "27px",
                      "campaign-item-576445-type": "CreateAccountCampaign",
                      "campaign-item-576446-action-tile-action-text": "Add My Birthday",
                      "campaign-item-576446-action-tile-birthday-ask-year": "false",
                      "campaign-item-576446-action-tile-birthday-thank-you-message": "Thanks! We're looking forward to helping you celebrate :)",
                      "campaign-item-576446-action-tile-message-text": "If your birthday is within the next 30 days, your reward will be granted in delay, up to 30 days.",
                      "campaign-item-576446-action-tile-title": "Earn 200 points on your birthday",
                      "campaign-item-576446-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576446-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576446-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_38_59_546",
                      "campaign-item-576446-background-type": "image",
                      "campaign-item-576446-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576446-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576446-description-font-size": "18px",
                      "campaign-item-576446-icon-color": "#768cdc",
                      "campaign-item-576446-icon-type": "customIcon",
                      "campaign-item-576446-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_39_11_289",
                      "campaign-item-576446-tile-description": "Birthday Reward",
                      "campaign-item-576446-tile-reward": "200 Points",
                      "campaign-item-576446-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576446-title-font-size": "27px",
                      "campaign-item-576446-type": "BirthdayCampaign",
                      "campaign-item-576448-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576448-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576448-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_39_36_553",
                      "campaign-item-576448-background-type": "image",
                      "campaign-item-576448-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576448-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576448-description-font-size": "18px",
                      "campaign-item-576448-hover-view-tile-message": "Upload a photo with your next review and earn 50 points",
                      "campaign-item-576448-icon-color": "#768cdc",
                      "campaign-item-576448-icon-type": "customIcon",
                      "campaign-item-576448-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_41_57_463",
                      "campaign-item-576448-tile-description": "Review with Photo/Video",
                      "campaign-item-576448-tile-reward": "50 points",
                      "campaign-item-576448-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576448-title-font-size": "27px",
                      "campaign-item-576448-type": "YotpoReviewImageCampaign",
                      "campaign-item-576451-action-tile-action-text": "Follow Us",
                      "campaign-item-576451-action-tile-title": "Earn 25 points when you follow us on Instagram",
                      "campaign-item-576451-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576451-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576451-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_44_19_101",
                      "campaign-item-576451-background-type": "image",
                      "campaign-item-576451-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-576451-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576451-description-font-size": "18px",
                      "campaign-item-576451-icon-color": "#768cdc",
                      "campaign-item-576451-icon-type": "customIcon",
                      "campaign-item-576451-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_09_11_45_47_057",
                      "campaign-item-576451-tile-description": "Follow us on IG",
                      "campaign-item-576451-tile-reward": "25 Points",
                      "campaign-item-576451-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-576451-title-font-size": "27px",
                      "campaign-item-576451-type": "InstagramFollowCampaign",
                      "campaign-item-685100-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-685100-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-685100-background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_03_31_18_33_00_969",
                      "campaign-item-685100-background-type": "image",
                      "campaign-item-685100-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-685100-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-685100-description-font-size": "18px",
                      "campaign-item-685100-hover-view-tile-message": "Earn 100 points when you Purchase a Snack or Sling Pack",
                      "campaign-item-685100-icon-color": "#768cdc",
                      "campaign-item-685100-icon-type": "customIcon",
                      "campaign-item-685100-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2021_03_31_18_26_49_734",
                      "campaign-item-685100-tile-description": "Purchase a Snack or Sling Pack",
                      "campaign-item-685100-tile-reward": "100 Points",
                      "campaign-item-685100-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-685100-title-font-size": "27px",
                      "campaign-item-685100-type": "TransactionBasedCampaign",
                      "campaign-item-828433-action-tile-action-text": "Claim Points",
                      "campaign-item-828433-action-tile-title": "Earn 200 points when you click the link",
                      "campaign-item-828433-background-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-828433-background-image-color-overlay": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-828433-background-type": "image",
                      "campaign-item-828433-border-color": "rgba( 0, 0, 0, 0 )",
                      "campaign-item-828433-description-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-828433-description-font-size": "18px",
                      "campaign-item-828433-displayname": "campaign-item-828433",
                      "campaign-item-828433-icon-color": "#768cdc",
                      "campaign-item-828433-icon-type": "defaultIcon",
                      "campaign-item-828433-tile-description": "1,000 Member Bonus",
                      "campaign-item-828433-tile-reward": "200 Points",
                      "campaign-item-828433-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-item-828433-title-font-size": "27px",
                      "campaign-item-828433-type": "FacebookPageVisitCampaign",
                      "campaign-item-828433-view-show-custom-action-button": "false",
                      "campaign-title-font-color": "rgba( 255, 255, 255, 1 )",
                      "campaign-title-size": "27px",
                      "completed-tile-headline": "Completed",
                      "completed-tile-message": "You already completed this campaign",
                      "container-headline": "Ways to earn points",
                      "general-hover-tile-button-color": "rgba(160,215,240,1)",
                      "general-hover-tile-button-text-color": "rgba( 255, 255, 255, 1 )",
                      "general-hover-tile-button-type": "rounded_filled_rectangle",
                      "general-hover-tile-color-overlay": "rgba( 47, 80, 176, 1 )",
                      "general-hover-tile-text-color": "#ffffff",
                      "headline-font-color": "rgba(160,215,240,1)",
                      "headline-font-size": 50,
                      "logged-out-is-redirect-after-login-to-current-page": "true",
                      "logged-out-message": "Already a member?",
                      "logged-out-sign-in-text": "Log in",
                      "logged-out-sign-up-text": "Sign up",
                      "main-text-font-name-and-url": "\"Greycliff CF\"@|",
                      "secondary-text-font-name-and-url": "\"SF Pro Display\"@|",
                      "selected-extensions": [
                        "576445",
                        "576444",
                        "576446",
                        "685100",
                        "576448",
                        "1040206",
                        "576451",
                        "828433",
                        "1040183",
                        "1040198",
                        "382924"
                      ],
                      "tile-border-color": "rgba( 0, 0, 0, 0 )",
                      "tile-spacing-type": "small",
                      "tiles-background-color": "rgba( 0, 0, 0, 0 )",
                      "time-between-rewards-days": "You're eligible to participate again in *|days|* days.",
                      "time-between-rewards-hours": "You're eligible to participate again in *|hours|* hours."
                    },
                    staticContent: {
                      "companyName": "Lunchbox",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "facebookAppId": "1647129615540489",
                      "isSegmentationsPickerEnabled": "true",
                      "merchantId": "57491",
                      "platformName": "shopify",
                      "storeAccountLoginUrl": "//www.itsmylunchbox.com/account/login",
                      "storeAccountRegistrationUrl": "//www.itsmylunchbox.com/account/register"
                    },
                    className: "CampaignWidget",
                    dependencyGroupId: 2
                },
            
                "8657": {
                    instanceId: "8657",
                    instanceVersionId: "6967675",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-my-rewards/app.v0.1.5-2264.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/MyRewardsWidget/a-wU-__6WAR57OA-e60oyQ/css-overrides/css-overrides.2021_04_05_21_58_48_141.css",
                    customizationCssUrl: "",
                    customizations: {
                      "logged-in-description-color": "rgba( 47, 80, 176, 1 )",
                      "logged-in-description-font-size": 27,
                      "logged-in-description-text": "You Have {{current_point_balance}} Points",
                      "logged-in-headline-color": "rgba( 47, 80, 176, 1 )",
                      "logged-in-headline-font-size": 53,
                      "logged-in-headline-text": "Hi {{first_name}} {{last_name}}",
                      "logged-in-primary-button-cta-type": "redemptionWidget",
                      "logged-in-primary-button-text": "Redeem Now",
                      "logged-in-secondary-button-text": "Rewards History",
                      "logged-out-headline-color": "rgba( 47, 80, 176, 1 )",
                      "logged-out-headline-font-size": 53,
                      "logged-out-headline-text": "How It Works",
                      "logged-out-selected-step-name": "step_1",
                      "primary-button-background-color": "rgba( 174, 178, 242, 1 )",
                      "primary-button-text-color": "#ffffff",
                      "primary-button-type": "filled_rectangle",
                      "primary-font-name-and-url": "'Greycliff CF'@|",
                      "reward-step-1-displayname": "Step 1",
                      "reward-step-1-settings-description": "Create an account and \nstart earning.",
                      "reward-step-1-settings-description-color": "rgba( 47, 80, 176, 1 )",
                      "reward-step-1-settings-description-font-size": 16,
                      "reward-step-1-settings-icon": "custom",
                      "reward-step-1-settings-icon-color": "#b7c6f8",
                      "reward-step-1-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_07_13_57_50_414",
                      "reward-step-1-settings-title": "Join",
                      "reward-step-1-settings-title-color": "rgba( 47, 80, 176, 1 )",
                      "reward-step-1-settings-title-font-size": 26,
                      "reward-step-2-displayname": "Step 2",
                      "reward-step-2-settings-description": "Earn points every time\nyou shop.",
                      "reward-step-2-settings-description-color": "rgba( 47, 80, 176, 1 )",
                      "reward-step-2-settings-description-font-size": 16,
                      "reward-step-2-settings-icon": "custom",
                      "reward-step-2-settings-icon-color": "#b7c6f8",
                      "reward-step-2-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_07_13_58_47_904",
                      "reward-step-2-settings-title": "Earn",
                      "reward-step-2-settings-title-color": "rgba( 47, 80, 176, 1 )",
                      "reward-step-2-settings-title-font-size": 26,
                      "reward-step-3-displayname": "Step 3",
                      "reward-step-3-settings-description": "Redeem points \nfor exclusive discounts.",
                      "reward-step-3-settings-description-color": "rgba( 47, 80, 176, 1 )",
                      "reward-step-3-settings-description-font-size": 16,
                      "reward-step-3-settings-icon": "custom",
                      "reward-step-3-settings-icon-color": "#b7c6f8",
                      "reward-step-3-settings-icon-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_07_13_59_24_904",
                      "reward-step-3-settings-title": "Redeem",
                      "reward-step-3-settings-title-color": "rgba( 47, 80, 176, 1 )",
                      "reward-step-3-settings-title-font-size": 26,
                      "rewards-history-approved-text": "Approved",
                      "rewards-history-background-color": "rgba(1,18,71,0.8)",
                      "rewards-history-headline-color": "rgba( 0, 0, 0, 1 )",
                      "rewards-history-headline-font-size": 28,
                      "rewards-history-headline-text": "Rewards History",
                      "rewards-history-pending-text": "Pending",
                      "rewards-history-refunded-text": "Refunded",
                      "rewards-history-reversed-text": "Reversed",
                      "rewards-history-table-action-col-text": "Action",
                      "rewards-history-table-date-col-text": "Date",
                      "rewards-history-table-points-col-text": "Points",
                      "rewards-history-table-status-col-text": "Status",
                      "secondary-button-background-color": "rgba( 174, 178, 242, 1 )",
                      "secondary-button-text-color": "rgba( 255, 255, 255, 1 )",
                      "secondary-button-type": "filled_rectangle",
                      "secondary-font-name-and-url": "\"SF Pro Display\"@|",
                      "view-grid-points-column-color": "rgba( 0, 0, 0, 1 )",
                      "view-grid-rectangular-background-color": "rgba( 230, 236, 255, 0 )",
                      "view-grid-type": "rectangular",
                      "view-table-type": "rectangular"
                    },
                    staticContent: {
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "isMultiCurrencyEnabled": false,
                      "isMultiStoreMerchant": false,
                      "merchantId": "57491",
                      "platformName": "shopify"
                    },
                    className: "MyRewardsWidget",
                    dependencyGroupId: 2
                },
            
                "8643": {
                    instanceId: "8643",
                    instanceVersionId: "6964136",
                    templateAssetUrl: "https://cdn-widget-assets.yotpo.com/widget-referral-widget/app.v1.6.25-2417.js",
                    cssOverrideAssetUrl: "https://cdn-widget-assets.yotpo.com/ReferralWidget/a-wU-__6WAR57OA-e60oyQ/css-overrides/css-overrides.2021_04_07_01_36_47_988.css",
                    customizationCssUrl: "",
                    customizations: {
                      "background-color": "rgba(0,0,0,1)",
                      "background-image-url": "https://cdn-widget-assets.yotpo.com/static_assets/a-wU-__6WAR57OA-e60oyQ/images/image_2020_10_08_12_36_03_558",
                      "customer-email-view-button-text": "REFER NOW",
                      "customer-email-view-description": "Welcome your friends to the fam with $10 off their purchase of $100 or more (their first Lunchbox Hydration Pack!), and get 200 points for each successful referral. ",
                      "customer-email-view-header": "Introduce your friends to lunchbox",
                      "customer-email-view-input-placeholder": "Your email address goes here",
                      "customer-email-view-title": "Give $10 off, Get 200 points",
                      "default-toggle": true,
                      "description-color": "rgba(160,215,240,1)",
                      "description-font-size": "18px",
                      "final-view-button-text": "WELCOME MORE FAM",
                      "final-view-description": "Want to welcome more friends to the fam? Keep earning points by sharing your referral code in groupchats, your festival group, or online communities! ",
                      "final-view-error-description": "We were unable to send the referral link",
                      "final-view-error-text": "GO BACK",
                      "final-view-error-title": "SOMETHING WENT WRONG",
                      "final-view-title": "You've just made your friends' experiences better",
                      "fonts-primary-font-name-and-url": "\"Greycliff CF\"@|",
                      "fonts-secondary-font-name-and-url": "\"SF Pro Display\"@|",
                      "header-color": "rgba(160,215,240,1)",
                      "header-font-size": "28px",
                      "main-share-option-desktop": "main_share_copy_link",
                      "main-share-option-mobile": "main_share_copy_link",
                      "next-button-background-color": "rgba(169,169,238,1)",
                      "next-button-font-size": "18px",
                      "next-button-size": "small",
                      "next-button-text-color": "rgba( 255, 255, 255, 1 )",
                      "next-button-type": "rounded_filled_rectangle",
                      "referral-history-completed-points-text": "{{points}} POINTS",
                      "referral-history-completed-status-type": "text",
                      "referral-history-confirmed-status": "Completed",
                      "referral-history-pending-status": "Pending",
                      "referral-history-points-reward": 0,
                      "referral-history-redeem-text": "Now, the fun part! Simply redeem the points you've earned directly at cart.",
                      "referral-history-sumup-line-points-text": "{{points}} POINTS",
                      "referral-history-sumup-line-text": "Your Rewards",
                      "referral-views-button-text": "Send",
                      "referral-views-copy-link-button-text": "COPY LINK",
                      "referral-views-description": "Welcome your friends to the fam with $10 off their purchase of $100 or more (their first Lunchbox Hydration Pack!), and get 200 points for each successful referral. ",
                      "referral-views-email-share-body": "How does a discount off your first order at {{company_name}} sound? Use the link below and once you've shopped, I'll get a reward too.\n{{referral_link}}",
                      "referral-views-email-share-subject": "Discount to a Store You'll Love!",
                      "referral-views-email-share-type": "marketing_email",
                      "referral-views-header": "Refer new fam!",
                      "referral-views-personal-email-button-text": "SEND VIA MY EMAIL",
                      "referral-views-sms-button-text": "SEND VIA SMS",
                      "referral-views-title": "Give $10 off, Get 200 points",
                      "referral-views-whatsapp-button-text": "SEND VIA WHATSAPP",
                      "share-allow-copy-link": true,
                      "share-allow-email": true,
                      "share-allow-facebook": "false",
                      "share-allow-sms": "true",
                      "share-allow-twitter": "false",
                      "share-allow-whatsapp": "true",
                      "share-facebook-description": "Hey guys! I wanted to share this amazing deal from lunchbox packs before our next event together! Their packs are anti-theft, have insulated water systems, and are customizable with skins \u0026 lights! Use my link: {{referral_link}} for a free skin when you buy your lunchbox! ",
                      "share-facebook-header": "Get a Skin with your Lunchbox Hydration Pack",
                      "share-facebook-image-url": "",
                      "share-icons-color": "rgba(160,215,240,1)",
                      "share-settings-copyLink": true,
                      "share-settings-default-checkbox": true,
                      "share-settings-default-mobile-checkbox": true,
                      "share-settings-email": true,
                      "share-settings-facebook": true,
                      "share-settings-fbMessenger": true,
                      "share-settings-mobile-copyLink": true,
                      "share-settings-mobile-email": true,
                      "share-settings-mobile-facebook": true,
                      "share-settings-mobile-fbMessenger": true,
                      "share-settings-mobile-sms": true,
                      "share-settings-mobile-twitter": true,
                      "share-settings-mobile-whatsapp": true,
                      "share-settings-twitter": true,
                      "share-settings-whatsapp": true,
                      "share-sms-message": "Check out lunchbox! 🎒 They make anti-theft packs for live events, plus they're customizable and help you stay hydrated all day! Use {{referral_link}} for $10 off your first order of $100 or more and join the fam with me :) ",
                      "share-twitter-message": "These guys are great! Use my link: {{referral_link}} for a $20 free skin with your lunchbox! ",
                      "share-whatsapp-message": "Check out lunchbox! 🎒 They make anti-theft packs for live events, plus they're customizable and help you stay hydrated all day! Use {{referral_link}} for $10 off your first order of $100 or more and join the fam with me :) ",
                      "tab-size": "medium",
                      "tab-type": "rectangle",
                      "tab-view-primary-tab-text": "Refer new fam!",
                      "tab-view-secondary-tab-text": "Your Referrals",
                      "tile-color": "rgba(0,0,0,1)",
                      "title-color": "rgba(160,215,240,1)",
                      "title-font-size": "48px",
                      "view-exit-intent-enabled": false,
                      "view-exit-intent-mobile-timeout-ms": 10000,
                      "view-is-popup": "false",
                      "view-layout": "right",
                      "view-popup-delay-ms": 0,
                      "view-show-customer-name": "false",
                      "view-show-popup-on-exit": false,
                      "view-show-referral-history": "true",
                      "view-table-rectangular-dark-pending-color": "rgba( 156, 231, 241, 1 )",
                      "view-table-rectangular-light-pending-color": "rgba( 0, 0, 0, 0 )",
                      "view-table-selected-color": "rgba( 0, 0, 0, 0 )",
                      "view-table-theme": "light",
                      "view-table-type": "rectangular",
                      "wadmin-text-and-share-choose-sreen": "step_1"
                    },
                    staticContent: {
                      "companyName": "Lunchbox",
                      "cssEditorEnabled": "true",
                      "currency": "USD",
                      "hasPrimaryFontsFeature": true,
                      "merchantId": "57491",
                      "migrateTabColorToBackground": true,
                      "platformName": "shopify",
                      "referralHistoryEnabled": true,
                      "referralHost": "http://rwrd.io"
                    },
                    className: "ReferralWidget",
                    dependencyGroupId: 2
                },
            
            },
            guidStaticContent: {},
            dependencyGroups: {
                      "2": [
                        "https://cdn-widget-assets.yotpo.com/widget-vue-core/app.v0.1.0-2295.js"
                      ]
                    }
        },
        initializer: "https://cdn-widgetsrepository.yotpo.com/widget-assets/widgets-initializer/app.v0.7.0-5119.js",
        analytics: "https://cdn-widgetsrepository.yotpo.com/widget-assets/yotpo-pixel/2023-09-12_08-37-14/bundle.js"
    }
    
    
    const initWidgets = function (config, initializeWidgets = true) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        return widgetInitializer.initWidgets(initializeWidgets);
    };
    const initWidget = function (config, instanceId, widgetPlaceHolder) {
        const widgetInitializer = yotpoWidgetsContainer['yotpo_widget_initializer'](config);
        if (widgetInitializer.initWidget) {
            return widgetInitializer.initWidget(instanceId, widgetPlaceHolder);
        }
        console.error("initWidget is not supported widgetInitializer");
    };
    const onInitializerLoad = function (config) {
        const prevInitWidgets = yotpoWidgetsContainer.initWidgets;
        yotpoWidgetsContainer.initWidgets = function (initializeWidgets = true) {
            if (prevInitWidgets) {
                if (typeof Promise !== 'undefined' && Promise.all) {
                    return Promise.all([prevInitWidgets(initializeWidgets), initWidgets(config, initializeWidgets)]);
                }
                console.warn('[deprecated] promise is not supported in initWidgets');
                prevInitWidgets(initializeWidgets);
            }
            return initWidgets(config, initializeWidgets);
        }
        const prevInitWidget = yotpoWidgetsContainer.initWidget;
        yotpoWidgetsContainer.initWidget = function (instanceId, widgetPlaceHolder) {
            if (prevInitWidget) {
              prevInitWidget(instanceId, widgetPlaceHolder)
            }
            return initWidget(config, instanceId, widgetPlaceHolder);
        }
        const guidWidgetContainer = getGuidWidgetsContainer();
        guidWidgetContainer.initWidgets = function () {
            return initWidgets(config);
        }
        guidWidgetContainer.initWidgets();
    };
    function getGuidWidgetsContainer () {
        if (!yotpoWidgetsContainer.guids) {
            yotpoWidgetsContainer.guids = {};
        }
        if (!yotpoWidgetsContainer.guids[guid]) {
            yotpoWidgetsContainer.guids[guid] = {};
        }
        return yotpoWidgetsContainer.guids[guid];
    }
    const guidWidgetContainer = getGuidWidgetsContainer();
    guidWidgetContainer.config = loader.config;
    if (!guidWidgetContainer.yotpo_widget_scripts_loaded) {
        guidWidgetContainer.yotpo_widget_scripts_loaded = true;
        guidWidgetContainer.onInitializerLoad = function () { onInitializerLoad(loader.config) };
        
        loader.loadDep(loader.analytics, function () {}, 'defer');
        
        
        loader.loadDep(loader.initializer, function () { guidWidgetContainer.onInitializerLoad() }, 'async');
        
    }
})()

